module.exports = "<div class=\"output-tabs-region\"></div>";